import React, { useState, useEffect } from 'react';
import {
  Button,
  Typography,
  Box,
} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBadge from "components/MKBadge";
import MKAvatar from "components/MKAvatar";
import MKButton from "components/MKButton";
import routes from "trainingCompanyEditRoutes";
import { useParams } from "react-router-dom";
import Logo from "assets/images/skill3.png";
import Breadcrumbs from "examples/Breadcrumbs";
import { LocationOn } from '@mui/icons-material';
import SimpleFooter from "examples/Footers/SimpleFooter";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MKAlert from "components/MKAlert";
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

function Author() {
  const { trainerID } = useParams();
  const [trainerList, setTrainerList] = useState([]);
  const [bbdata, setbbData] = useState([]);
  const [trainingList, setTrainingList] = useState([]);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedTrainer, setSelectedTrainer] = useState([]);
  const [socialMedia, setSocialMedia] = useState('');
  const [educationDetails, setEducationDetails] = useState('');
  const [workExperience, setWorkExperience] = useState('');
  const [personalDetails, setPersonalDetails] = useState('');
  const [personalDetailsAddress, setPersonalDetailsAddress] = useState('');
  const [personalDetailsLanguage, setPersonalDetailsLanguage] = useState('');
  const [certifications, setCertifications] = useState('');
  const [trainingExperience, setTrainingExperience] = useState('');
  const [workSamples, setWorkSamples] = useState('');
  const [reference, setReference] = useState('');
  const [responseRecruitFromDB, setResponseRecruitFromDB] = useState('');
  const [maxRecruitCount, setMaxRecruitCount] = useState(false);
  const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');
  const [profilePicture, setProfilePicture] = useState(null);
  const [loginId, setLoginId] = useState('');
  const [loading, setLoading] = useState(false);
  const [trainingCompanyProfileDetails, setTrainingCompanyProfileDetails] = useState([])

  useEffect(() => {
    let id = localStorage.getItem("userId");
    fetch(`${process.env.REACT_APP_API_URL}/api/training-companyprofile-filter/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setTrainingCompanyProfileDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("trainingCompanyProfileDetails", trainingCompanyProfileDetails);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-list/${trainerID}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setbbData(data);
          setTrainerList(data);
          setProfilePicture(data.profilePictureName);
          setSocialMedia(data.socialMedia);
          setEducationDetails(data.educationDetails);
          setWorkExperience(data.workExperience);
          setPersonalDetails(data.personalDetails);
          let address = data.personalDetails.address;
          setPersonalDetailsAddress(address);
          let language = data.personalDetails.languages;
          setPersonalDetailsLanguage(language);
          setCertifications(data.certifications);
          setTrainingExperience(data.trainingExperience);
          setWorkSamples(data.workSample);
          setReference(data.referredBy);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("trainerList", trainerList);
  console.log("trainerList.trainerRating", trainerList.trainerRating);
  console.log("data", bbdata);
  console.log("educationDetails", educationDetails);
  console.log("workExperience", workExperience);
  console.log("personalDetails", personalDetails);
  console.log("personalDetailsAddress", personalDetailsAddress);
  console.log("personalDetailsLanguage", personalDetailsLanguage);
  console.log("certifications", certifications);
  console.log("trainingExperience", trainingExperience);
  console.log("workSamples", workSamples);
  console.log("reference", reference);

  const onConnectClick = (trainerList) => {
    setLoading(true);
    setMaxRecruitCount(false);
    let id = localStorage.getItem("userId");
    console.log("trainerList", trainerList)
    setSelectedTrainer(trainerList);
    // setSelectedTrainerId(trainer.id);
    const data = {
      trainingCompanyID: id,
      trainerID: trainerList.user_id,
      trainingCompanyRecruitStatus: "Yes",
      premiumStatus:trainingCompanyProfileDetails.premiumStatus,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/company-recruit-trainer/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setSubmitCompleted(false);
          throw new Error("Response not Submitted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("Response from backend:", data.message);
        if (data.message === "Remainder reached maximum for the day") {
          setResponseRecruitFromDB(data.message);
          setMaxRecruitCount(true);
        } else if (data.message === "We have sent you a link to the Trainer to accept your request") {
          setResponseRecruitFromDB(data.message);
          setSubmitCompleted(true);
        } else {
          setResponseRecruitFromDB(data.message);
          setSubmitCompleted(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };
  console.log("selectedTrainer", selectedTrainer);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    setLoginId(id);
  }, [localStorage.getItem("userId")]);

  const onCancelClick = () => {
    window.location.href = "/app/trainingcompanydashboard";
  };

  const handleFeedbackDownloadClick = (trainings) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${trainerList.S3BucketURL}/feedback/${trainings.uploadedFeedbackName}`;
  };

  const handleTocDownloadClick = (trainings) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${trainerList.S3BucketURL}/toc/${trainings.uploadedTocName}`;
  };

  const handleCertificateDownloadClick = (trainings) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${trainerList.S3BucketURL}/certificate/${trainings.uploadedCertificateName}`;
  };

  const handleWorkSampleDownloadClick = (trainings) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${trainerList.S3BucketURL}/workSample/${trainings.uploadedWorkSampleName}`;
  };

  const handleTrainerConnectOK = () => {
    setSubmitCompleted(false);
    window.location.href = "/app/trainingcompanydashboard";
  };

  return (
    <>
      <LoadingOverlay loading={loading}>
        <DefaultNavbar
          routes={routes}
        />
        <MKBox bgColor="white">
          <Card
            sx={{
              p: 2,
              mx: { xs: 2, lg: 3 },
              // mt: -8,
              mb: 4,
              // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
            }}
          >
            <Dialog
              open={submitCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Notification !
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your response has been sent to the trainer.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={handleTrainerConnectOK} variant="contained" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <MKBox component="section" py={{ xs: 6, sm: 12 }}>
              <Container>
                <div>
                  {maxRecruitCount ? (
                    <MKAlert color="error" dismissible >
                      You've reached the daily recruit limit !
                    </MKAlert>
                  ) : (
                    ""
                  )}
                </div>
                <Grid container item xs={12} justifyContent="center" mx="auto">
                  <MKBox textAlign="center">
                    <MKAvatar
                      // src={profilePicture} 
                      src={`${process.env.REACT_APP_API_URL}${profilePicture}/`}
                      alt="Burce Mars"
                      size="xxl"
                      shadow="xl"
                      style={{ backgroundColor: avatarBackgroundColor }} />
                  </MKBox>
                  <Grid container justifyContent="center" py={6} style={{ marginTop: "-40px" }}>
                    <Grid item xs={12} md={12} mx={{ xs: "auto", sm: 6, md: 1 }}>
                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Typography variant="h3">{trainerList.firstName}&nbsp;{trainerList.lastName}</Typography>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            {trainerList.skills}
                          </Typography>
                        </Grid>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            <LocationOn />
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            {trainerList.currentLocationCountry} | {trainerList.currentLocationState} | {trainerList.location}
                          </Typography>
                        </Grid>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Stack spacing={1} style={{ marginLeft: '5px' }}>
                            <Rating
                              name="read-only"
                              value={trainerList.trainerRating + 0.0}
                              precision={0.5}
                              readOnly
                            />
                          </Stack>
                        </Grid>
                      </MKBox>

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Basic Details</span> }]} />
                        </Grid>
                      </Grid>

                      <Grid container spacing={3} mb={1}>
                        <Grid item xs={3}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Date of Birth :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "37px" }}>
                            {personalDetails.dob}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Gender :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "37px" }}>
                            {personalDetails.gender}
                          </Typography>
                        </Grid>
                        <Grid item xs={3.5}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Total Experience :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                            {trainerList.totalExperience}&nbsp;months
                          </Typography>
                        </Grid>
                        <Grid item xs={3.5}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Mode Of Training :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "37px" }}>
                            {trainerList.trainingMode}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Williness to Travel Within the Country ?&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "47px" }}>
                            {trainerList.travelOutSideCountry === 'yes' ? 'Yes' : 'No'}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Williness to provide Individual Training ?&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "36px" }}>
                            {trainerList.individualTraining === 'yes' ? 'Yes' : 'No'}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Differently Abled ?&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "150px" }}>
                            {trainerList.differentlyAbled === 'yes' ? 'Yes' : 'No'}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Williness to Travel Outside the Country ?&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "37px" }}>
                            {trainerList.travelOutSideCountry === 'yes' ? 'Yes' : 'No'}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Williness to provide Weekend Training ?&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "40px" }}>
                            {trainerList.weekendTraining === 'yes' ? 'Yes' : 'No'}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Williness to Record Training ?&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                            {trainerList.recordTraining === 'yes' ? 'Yes' : 'No'}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={2}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Working Time Zone :&nbsp;
                          </Typography>
                        </Grid>
                        <Grid item xs={10}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                            {trainerList.workingTimeZone} <br />
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={2}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            About Trainer :&nbsp;
                          </Typography>
                        </Grid>
                        <Grid item xs={10}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                            {trainerList.profile} <br />
                          </Typography>
                        </Grid>
                      </Grid>

                      {trainingCompanyProfileDetails.premiumStatus === "yes" && (
                        // {getStatusMessage(trainingDetails) === "Mutually agreed for the training" && (
                        <>
                          <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                            <Grid item xs={12}>
                              <Breadcrumbs
                                routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Contact Details</span> }]}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Contact Person Name :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "37px" }}>
                                {trainerList.firstName}&nbsp;{trainerList.lastName}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                Email - ID :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "50px" }}>
                                {trainerList.email}&nbsp;
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                Mobile Number :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                                {trainerList.mobileNumber}&nbsp;
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      )}

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Average Commericals (per hour)</span> }]}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            For less than 4 hours :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "37px" }}>
                            {trainerList.currency}&nbsp;{trainerList.avgCommercialForLessthan4hrs}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            For 4 hours :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "50px" }}>
                            {trainerList.currency}&nbsp;{trainerList.avgCommercialFor4hrs}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            For 8 hours :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                            {trainerList.currency}&nbsp;{trainerList.avgCommercialFor8hrs}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Training Experience</span> }]}
                          />
                        </Grid>
                      </Grid>

                      {trainingExperience && trainingExperience.map((training, index) => (
                        <div key={index}>
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <MKBadge badgeContent={`Training Profile - ${training.profileName}`} color="secondary" variant="contained" container />
                          </div>
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={2}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Technology :&nbsp;
                              </Typography>
                            </Grid>
                            <Grid item xs={10}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "13px" }}>
                                {training.trainingTechnology}
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={2}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Client Delivered :&nbsp;
                              </Typography>
                            </Grid>
                            <Grid item xs={10}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "13px" }}>
                                {training.clientDelivered}
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Date of Last Training :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "51px" }}>
                                {training.dateOfLastTraining}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                Delivery Method :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "110px" }}>
                                {training.deliveryMethod}
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Training Duration :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "78px" }}>
                                {training.trainingDuration} hours
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                Total Trainings Delivered :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "50px" }}>
                                {training.totalNoOfTrainings}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                Total Training Expereince :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "50px" }}>
                                {training.totalTrainingExperience} months
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid container spacing={4} mb={1} style={{ marginBottom: "25px" }}>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Commercials For &lt;4 hrs (per hour) :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "20px" }}>
                                {training.commercialsCurrency}&nbsp;{training.forLessThan4hrs}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                Commercials For 4 hrs (per hour) :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "20px" }}>
                                {training.commercialsCurrency}&nbsp;{training.for4hrs}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                Commercials For 8 hrs (per hour) :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "20px" }}>
                                {training.commercialsCurrency}&nbsp;{training.for8hrs}
                              </Typography>
                            </Grid>
                          </Grid>


                          {training.projectTitle && (
                            <>
                              <Grid container spacing={4} mb={1}>
                                <Grid item xs={2}>
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                    Project Title :&nbsp;
                                  </Typography>
                                </Grid>
                                <Grid item xs={10}>
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                                    {training.projectTitle} <br />
                                  </Typography>
                                </Grid>
                              </Grid>
                            </>
                          )}

                          {training.projectTitle && (
                            <>
                              <Grid container spacing={4} mb={1}>
                                <Grid item xs={2}>
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                    Project Descritption :&nbsp;
                                  </Typography>
                                </Grid>
                                <Grid item xs={10}>
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                                    {training.projectDescription} <br />
                                  </Typography>
                                </Grid>
                              </Grid>
                            </>
                          )}

                          {training.demoLink && (
                            <>
                              <Grid container spacing={4} mb={1}>
                                <Grid item xs={12}>
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                    Demo Video Link :&nbsp;
                                  </Typography>
                                  {training && (
                                    <a
                                      href={training.demoLink.startsWith("http") ? training.demoLink : `http://${training.demoLink}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ marginLeft: "18px", textDecoration: "underline" }}
                                    >
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "50px", textDecoration: "underline", color: "blue" }}>
                                        {training.demoLink}
                                      </Typography>
                                    </a>
                                  )}
                                </Grid>
                              </Grid>
                            </>
                          )}

                          <Grid container spacing={4} mb={1}>
                            {training.uploadedFeedbackName && (
                              <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'center' }}>
                                <MKButton
                                  variant="gradient"
                                  color="info"
                                  size="small"
                                  style={{ padding: '5px 10px' }}
                                  onClick={() => handleFeedbackDownloadClick(training)}
                                >
                                  Download Feedback
                                </MKButton>
                              </Grid>
                            )}

                            {training.uploadedTocName && (
                              <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'center' }}>
                                <MKButton
                                  variant="gradient"
                                  color="info"
                                  size="small"
                                  style={{ padding: '5px 10px' }}
                                  onClick={() => handleTocDownloadClick(training)}
                                >
                                  Download TOC
                                </MKButton>
                              </Grid>
                            )}
                          </Grid>

                        </div>
                      ))}

                      {workExperience && (
                        <>
                          <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                            <Grid item xs={12}>
                              <Breadcrumbs
                                routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Work Experience</span> }]}
                              />
                            </Grid>
                          </Grid>

                          {workExperience && workExperience.map((work, index) => (
                            <div key={index}>
                              <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <MKBadge badgeContent={`Work Experience ${index + 1}`} color="secondary" variant="contained" container />
                              </div>

                              {work.companyName && work.designation && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={5.5}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Company Name :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "72px" }}>
                                        {work.companyName}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={6.5}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "10px" }}>
                                        Designation :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "40px" }}>
                                        {work.designation}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                              {work.dateOfJoining && work.dateOfLeaving && work.employmentType && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Date of Joining :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "78px" }}>
                                        {work.dateOfJoining}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                        Date of Leaving :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "50px" }}>
                                        {work.dateOfLeaving}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                        Employment Type :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "50px" }}>
                                        {work.employmentType}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                              {work.technology && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={2}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Skills :&nbsp;
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                                        {work.technology}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                              {work.jobProfile && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={2}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Job Profile :&nbsp;
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                                        {work.jobProfile} <br />
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                            </div>
                          ))}
                        </>
                      )}

                      {educationDetails && (
                        <>
                          <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                            <Grid item xs={12}>
                              <Breadcrumbs
                                routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Education Details</span> }]}
                              />
                            </Grid>
                          </Grid>
                          {educationDetails && educationDetails.map((edu, index) => (
                            <div key={index}>
                              <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <MKBadge badgeContent={`Education Details ${index + 1}`} color="secondary" variant="contained" container />
                              </div>

                              {edu.education && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={6}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Education :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "74px" }}>
                                        {edu.education}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                              {edu.university && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={6}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        University :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "75px" }}>
                                        {edu.university}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                              {edu.course && edu.specialization && edu.modeOfLearning && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Course :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "95px" }}>
                                        {edu.course}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                        Specialization :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "50px" }}>
                                        {edu.specialization}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                        Mode of Learning :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "50px" }}>
                                        {edu.modeOfLearning}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                              {edu.mark && edu.fromYear && edu.toYear && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        From Year :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "73px" }}>
                                        {edu.fromYear}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                        To Year :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "97px" }}>
                                        {edu.toYear}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                        Grade / Mark (in %) :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "40px" }}>
                                        {edu.mark}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}
                            </div>
                          ))}
                        </>
                      )}

                      {certifications && (
                        <>
                          <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                            <Grid item xs={12}>
                              <Breadcrumbs
                                routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Certifications</span> }]}
                              />
                            </Grid>
                          </Grid>

                          {certifications && certifications.map((certificate, index) => (
                            <div key={index}>
                              <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <MKBadge badgeContent={`Certification ${index + 1}`} color="secondary" variant="contained" container />
                              </div>

                              {certificate.certificationName && certificate.technology && certificate.certificationId && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Certification Name :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "65px" }}>
                                        {certificate.certificationName}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                        Technology :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "40px" }}>
                                        {certificate.technology}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                        Certification Id :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "75px" }}>
                                        {certificate.certificationId}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                              {certificate.certificateNeverExpires === 'true' && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Certificate Never Expires :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "22px" }}>
                                        {certificate.certificateNeverExpires === 'true' ? 'Yes' : 'No'}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                              {certificate.certificateNeverExpires !== 'true' && (
                                <Grid container spacing={4} mb={1}>
                                  <Grid item xs={4}>
                                    <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                      Certification Valid From :&nbsp;
                                    </Typography>
                                    <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "30px" }}>
                                      {certificate.certificationFromYear}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={4}>
                                    <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                      Certification Valid From :&nbsp;
                                    </Typography>
                                    <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "35px" }}>
                                      {certificate.certificationToYear}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              )}

                              {certificate.url && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={12}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Certificate URL :&nbsp;
                                      </Typography>
                                      {certificate && (
                                        <a
                                          href={certificate.url.startsWith("http") ? certificate.url : `http://${certificate.url}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{ marginLeft: "32px", textDecoration: "underline" }}
                                        >
                                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "61px", textDecoration: "underline", color: "blue" }}>
                                            {certificate.url}
                                          </Typography>
                                        </a>
                                      )}
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                              {certificate.uploadedCertificateName && (
                                <Grid container spacing={4} mb={1}>
                                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                    <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleCertificateDownloadClick(certificate)}>
                                      Download Certificate
                                    </MKButton>
                                  </Grid>
                                </Grid>
                              )}

                            </div>
                          ))}
                        </>
                      )}

                      {reference && (
                        <>
                          <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                            <Grid item xs={12}>
                              <Breadcrumbs
                                routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer Referred By</span> }]}
                              />
                            </Grid>
                          </Grid>

                          {reference && reference.map((refer, index) => (
                            <div key={index}>
                              <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <MKBadge badgeContent={`Referral ${index + 1}`} color="secondary" variant="contained" container />
                              </div>

                              {refer.referredBySalutation && refer.referredByFirstName && refer.referredByLastName && refer.referenceContactCountryCode && refer.referredByMobileNumber && refer.referredByEmailID && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Referral Name :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "65px" }}>
                                        {refer.referredBySalutation}&nbsp;{refer.referredByFirstName}&nbsp;{refer.referredByLastName}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                        Contact Number :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "40px" }}>
                                        {refer.referenceContactCountryCode}&nbsp;{refer.referredByMobileNumber}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                        Email Id :&nbsp;
                                      </Typography>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "75px" }}>
                                        {refer.referredByEmailID}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                            </div>
                          ))}
                        </>
                      )}

                      <div>
                        <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                          <Grid item xs={12}>
                            <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Language proficiency</span> }]} />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Language</span> }]} />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Read</span> }]} />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Write</span> }]} />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Speak</span> }]} />
                          </Grid>

                          {Object.values(personalDetailsLanguage).map((language, index) => (
                            <React.Fragment key={index}>
                              <Grid item xs={12} md={3} justifyContent="center">
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                  {language.language}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} md={3} container justifyContent="center">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={Boolean(language.read)}
                                    />
                                  }
                                // label="Read"
                                />
                              </Grid>
                              <Grid item xs={12} md={3} container justifyContent="center">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={Boolean(language.write)}
                                    />
                                  }
                                // label="Write"
                                />
                              </Grid>
                              <Grid item xs={12} md={3} container justifyContent="center">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={Boolean(language.speak)}
                                    />
                                  }
                                // label="Speak"
                                />
                              </Grid>
                            </React.Fragment>
                          ))}
                        </Grid>
                      </div>

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Address Details</span> }]} />
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={6}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Address Line 1 :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "95px" }}>
                            {personalDetailsAddress.addressLine1}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Address Line 2 :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "50px" }}>
                            {personalDetailsAddress.addressLine2}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={3}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Country :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "65px" }}>
                            {personalDetailsAddress.country}
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            State :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "40px" }}>
                            {personalDetailsAddress.state}
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            City :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "75px" }}>
                            {personalDetailsAddress.city}
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Pincode :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "75px" }}>
                            {personalDetailsAddress.pincode}
                          </Typography>
                        </Grid>
                      </Grid>

                      {workSamples && (
                        <>
                          <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                            <Grid item xs={12}>
                              <Breadcrumbs
                                routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Work Sample Details</span> }]}
                              />
                            </Grid>
                          </Grid>

                          {workSamples && workSamples.map((work, index) => (
                            <div key={index}>
                              <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <MKBadge badgeContent={`Work Sample ${index + 1}`} color="secondary" variant="contained" container />
                              </div>

                              {work.title && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={2}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Work Sample Title :&nbsp;
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                                        {work.title}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                              {work.description && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={2}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "15px" }}>
                                        Work Sample Description :&nbsp;
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                                        {work.description}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              )}

                              {work.workUrl && (
                                <>
                                  <Grid container spacing={4} mb={1}>
                                    <Grid item xs={12}>
                                      <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                        Work Sample URL :&nbsp;
                                      </Typography>
                                      {work && (
                                        <a
                                          href={work.workUrl.startsWith("http") ? work.workUrl : `http://${work.workUrl}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{ marginLeft: "32px", textDecoration: "underline" }}
                                        >
                                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "28px", textDecoration: "underline", color: "blue" }}>
                                            {work.workUrl}
                                          </Typography>
                                        </a>
                                      )}
                                    </Grid>
                                  </Grid>
                                </>
                              )}
                              {work.uploadedWorkSampleName && (
                                <Grid container spacing={4} mb={1}>
                                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                    <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleWorkSampleDownloadClick(work)}>
                                      Download Work Sample Document
                                    </MKButton>
                                  </Grid>
                                </Grid>
                              )}
                            </div>
                          ))}
                        </>
                      )}

                      {socialMedia && (
                        <>
                          <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                            <Grid item xs={12}>
                              <Breadcrumbs
                                routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Social Media Details</span> }]}
                              />
                            </Grid>
                          </Grid>

                          <Grid container spacing={1} mb={1}>
                            <Grid item>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                LinkedIn URL :&nbsp;
                              </Typography>
                              {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl && (
                                <a
                                  href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginLeft: "5px", textDecoration: "underline" }}
                                >
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "49px", textDecoration: "underline", color: "blue" }}>
                                    {JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl}
                                  </Typography>
                                </a>
                              )}
                            </Grid>
                          </Grid>

                          <Grid container spacing={1} mb={1}>
                            <Grid item>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Facebook URL :&nbsp;
                              </Typography>
                              {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl && (
                                <a
                                  href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginLeft: "5px", textDecoration: "underline" }}
                                >
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "40px", textDecoration: "underline", color: "blue" }}>
                                    {JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl}
                                  </Typography>
                                </a>
                              )}
                            </Grid>
                          </Grid>

                          <Grid container spacing={1} mb={1}>
                            <Grid item>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Twitter URL :&nbsp;
                              </Typography>
                              {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl && (
                                <a
                                  href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginLeft: "5px", textDecoration: "underline" }}
                                >
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "61px", textDecoration: "underline", color: "blue" }}>
                                    {JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl}
                                  </Typography>
                                </a>
                              )}
                            </Grid>
                          </Grid>

                          <Grid container spacing={1} mb={1}>
                            <Grid item>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Instagram URL :&nbsp;
                              </Typography>
                              {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl && (
                                <a
                                  href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginLeft: "5px", textDecoration: "underline" }}
                                >
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "38px", textDecoration: "underline", color: "blue" }}>
                                    {JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl}
                                  </Typography>
                                </a>
                              )}
                            </Grid>
                          </Grid>

                          <Grid container spacing={1} mb={1}>
                            <Grid item>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                GitHub URL :&nbsp;
                              </Typography>
                              {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl && (
                                <a
                                  href={JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginLeft: "5px", textDecoration: "underline" }}
                                >
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "61px", textDecoration: "underline", color: "blue" }}>
                                    {JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl}
                                  </Typography>
                                </a>
                              )}

                            </Grid>
                          </Grid>

                          <Grid container spacing={1} mb={1}>
                            <Grid item>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Youtube URL :&nbsp;
                              </Typography>
                              {socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl && (
                                <a
                                  href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginLeft: "5px", textDecoration: "underline" }}
                                >
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "52px", textDecoration: "underline", color: "blue" }}>
                                    {JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl}
                                  </Typography>
                                </a>
                              )}
                            </Grid>
                          </Grid>
                        </>
                      )}

                    </Grid>
                  </Grid>
                  <Grid container justifyContent="center" spacing={2} mt={2} style={{ marginTop: "-40px", marginBottom: "-80px" }}>
                    {loginId === '' ? (
                      <Grid item>
                        <MKButton
                          variant="gradient"
                          color="info"
                          size="small"
                          onClick={() => onCancelClick()}
                          style={{ padding: '5px 10px' }}
                        >
                          Back
                        </MKButton>
                      </Grid>
                    ) : null}
                    <Grid item>
                      <MKButton
                        variant="gradient"
                        color="info"
                        size="small"
                        onClick={() => onConnectClick(trainerList)}
                        style={{ padding: '5px 10px' }}
                      >
                        Connect
                      </MKButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Container>
            </MKBox>
          </Card>
          <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
              <SimpleFooter />
            </MKBox>
          </div>
        </MKBox>
      </LoadingOverlay>
    </>
  );
}

export default Author;
